<script lang="ts" setup>
import { computed } from 'vue';
import { DataPoint } from '@/types';
import { getDefaultLocaleValue } from '../locales/default';

const props = defineProps<{
  dataPoint: any;
  locale: string;
  parentLabel: string;
  label: any;
  translations: Record<string, string>;
}>();

function isValidDataPoint(dataPoint: DataPoint | null) {
  return dataPoint && (dataPoint.value || (dataPoint.min && dataPoint.max));
}

function getDataPointString(dataPoint: DataPoint) {
  switch (true) {
    // TODO Remove the second check once we can create appropriate objects in tests
    case dataPoint.value && dataPoint.value !== 0:
      // in the Body/Karosserie accordion, number of doors and seats has no unit
      const unit = dataPoint.unit ? dataPoint.unit : '';
      return `${dataPoint.value.toLocaleString(props.locale)} ${unit}`;
    case dataPoint.max && dataPoint.min && dataPoint.max === dataPoint.min:
      return `${dataPoint.max.toLocaleString(props.locale)} ${dataPoint.unit}`;
    case [dataPoint.max, dataPoint.min].every((e) => e != undefined):
      return `${dataPoint.min!!.toLocaleString(props.locale)} - ${dataPoint.max!!.toLocaleString(props.locale)} ${dataPoint.unit}`;
    default:
      return '';
  }
}

const value = computed((): string => {
  return getDataPointString(props.dataPoint);
});
</script>

<template>
  <div
    class="wb-grid-col wb-grid-col-mq5-3 wb-grid-col-mq3-5 wb-grid-col-mq1-7"
    v-if="isValidDataPoint(props.dataPoint)"
  >
    <dl class="td-values-item">
      <dt class="label wb-text-s">
        {{
          props.translations[`owvc_tech_data_${parentLabel}_${label}`] ||
          getDefaultLocaleValue(`${parentLabel}_${label}`)
        }}
      </dt>
      <dd class="value wb-heading-m">{{ value.toLocaleString() }}</dd>
    </dl>
  </div>
</template>

<style lang="scss" scoped>
@import '@workbench/core/dist/scss/utility.scss';

.td-values-item {
  @include wb-spacing('margin-bottom', 'xs');
  @include wb-spacing('padding-left', 'xxs');
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-start;
  border-left: var(--wb-grey-85) 1px solid;
  .value {
    margin: 0;
  }
}

.label {
  color: var(--wb-grey-20);
}

.wb-grid-col {
  width: 100%;
}
</style>
